import { useTheme } from "@emotion/react";

import { ListStack, useThemeProps, withDefaultProps } from "../../wsui/base";

import DefaultHitComponent from "./HitController.jsx";

export default function DefaultHits(props) {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  props = useThemeProps({ props, name: "AlgoliaDefaultHits" });
  let {
    hitComponent: Hit = DefaultHitComponent,
    as: Component = withDefaultProps(ListStack, {
      spacing: 4,
      divider: true,
      ordered: true,
    }),
    hits,
    ownerState,
    ...restProps
  } = props;

  return (
    <Component {...restProps}>
      {hits.map((hit, index) => {
        return (
          <Hit
            hit={hit}
            key={index}
            index={index}
            hitsOwnerState={ownerState}
          />
        );
      })}
    </Component>
  );
}
